import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isAvailableParameter' })
export class IsAvailableParameterPipe implements PipeTransform {
  transform(key: string, availableParameters: string[]): boolean {
    return availableParameters.includes(key);
  }
}
